import { createRouter, createWebHistory } from 'vue-router';
import LandingComponent from '@/components/Landing.vue';
import HomeComponent from '@/components/Home.vue';
import TermsOfUse from '@/components/legal/TermsOfUse.vue';
import CookiePolicy from '@/components/legal/CookiePolicy.vue';
import LegalComponent from '@/components/Legal.vue';
import { msalPluginInstance } from '@/plugins/msal-plugin';

const routes = [
  { path: '/', name: 'landing', component: LandingComponent },
  { path: '/home', name: 'home', component: HomeComponent },
  {
    path: '/legal',
    component: LegalComponent,
    children: [
      { path: '/terms', component: TermsOfUse },
      { path: '/cookies', component: CookiePolicy },
    ],
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Return-style guard: the next() callback is deprecated in vue-router 5
router.beforeEach((to) => {
  if (to.name === 'home' && !msalPluginInstance.isAuthenticated) return { name: 'landing' };
});
